<template>
  <div v-bind:class="{'col-lg-6': !this.subSection}"
       v-if="displayDocument"
  >
    <div class="m-t">
      <div class="bg-muted p-xs b-r-sm document"
           v-bind:class="{ 'document-red': this.documentRed, 'document-orange': this.documentOrange, 'document-green': this.document.id && this.document.valid }">
        <div class="row">
          <div class="col-lg-6 document-title">
            <label v-if="this.document.id && this.document.valid" class="document-label">
              <input v-if="this.document.page !== 'owner'" type="checkbox" v-model="validDocumentCheckBox" @click="updateCheckedValidDocumentsList(document.id, true)">
              <span v-if="this.document.page !== 'owner'" class="checkmark"></span>
              {{ document.title }}
            </label>
            <span v-else>
              {{ document.title }}
              <span v-if="required" class="fa fa-lg fa-exclamation-circle text-warning" title="Document obligatoire"></span>
            </span>
          </div>
          <div v-if="document.code !== 'newCG'" class="text-right m-r">
            <input
               type="file"
               style="display: none;"
               :ref="document.code"
               @change="e => uploadFile(e, document.code)"
            />
            <div class="tooltip-demo" v-if="document.code === 'warrantyCertificate' || document.code === 'warrantyCertificateCarizy'">
              <button
                v-if="this.document.info && this.document.page !== 'partner'"
                v-tooltip.top-center="info[this.document.info]"
                class="btn btn-default btn-circle btn-info-doc"
              >
                <i class="fa fa-info-circle"></i>
              </button>
              <button
                v-if="this.document.infoPartner && this.document.page === 'partner'"
                v-tooltip.top-center="infoPartner[this.document.infoPartner]"
                class="btn btn-default btn-circle btn-info-doc"
              >
                <i class="fa fa-info-circle"></i>
              </button>
              <template v-if="document.id">
                <button
                  v-if="showShowIcon"
                  @click="fetchDocument(document.id)"
                  class="btn btn-default btn-circle"
                  v-tooltip.top-center="'Visualiser'"
                >
                  <i class="fa fa-eye"></i>
                </button>
                <button
                  v-if="showDownloadIcon"
                  @click="downloadDocument(document.id)"
                  class="btn btn-default btn-circle"
                  v-tooltip.top-center="'Télécharger'"
                >
                    <i class="fa fa-download"></i>
                </button>
                <button
                  v-if="this.document.page !== 'partner' && document.canEdit"
                  @click="$refs[`${document.code}`].click()"
                  class="btn btn-default btn-circle"
                  v-tooltip.top-center="'Editer'"
                >
                  <i class="fa fa-pencil" style="color: inherit"></i>
                </button>
                <button
                  v-if="document.valid === true && this.document.page !== 'partner'"
                  class="btn btn-none btn-sm text-info"
                >
                  <small><i class="fa fa-check"></i> Conforme</small>
                </button>
                <button
                  v-if="document.valid === null && this.document.page !== 'partner'"
                  @click="showValidationModal()"
                  v-tooltip.top-center="'Valider ce document'"
                  class="btn btn-primary btn-sm"
                >
                  <small><i class="fa fa-gavel"></i>  Conforme</small>
                </button>
                <span
                  v-if="document.valid === false && this.document.page !== 'partner'"
                  v-tooltip.top-center="'Ce document est non conforme'"
                  class="notValid"
                >
                  <small><i class="fa fa-times"></i>  Non conforme</small>
                </span>
              </template>
              <template v-else>
                <button
                        v-if="this.document.page !== 'partner' && !uploadFileIsLoading && document.canEdit"
                        @click="$refs[`${document.code}`].click()"
                        class="btn btn-primary btn-circle"
                        v-tooltip.top-center="'Déposer le document'"
                >
                  <i class="fa fa-plus"></i>
                </button>
                <spinner-circle class="float-right" :displayNone="!uploadFileIsLoading"/>
              </template>
            </div>
            <div class="tooltip-demo" v-else>
              <button
                  v-if="this.document.info && this.document.page !== 'partner'"
                  v-tooltip.top-center="info[this.document.info]"
                  class="btn btn-default btn-circle btn-info-doc"
              >
                <i class="fa fa-info-circle"></i>
              </button>
              <button
                  v-if="this.document.infoPartner && this.document.page === 'partner'"
                  v-tooltip.top-center="infoPartner[this.document.infoPartner]"
                  class="btn btn-default btn-circle btn-info-doc"
              >
                <i class="fa fa-info-circle"></i>
              </button>
              <template v-if="document.id">
                <button
                    v-if="showShowIcon"
                    @click="fetchDocument(document.id)"
                    class="btn btn-default btn-circle"
                    v-tooltip.top-center="'Visualiser'"
                >
                  <i class="fa fa-eye"></i>
                </button>
                <button
                    v-if="showDownloadIcon"
                    @click="downloadDocument(document.id)"
                    class="btn btn-default btn-circle"
                    v-tooltip.top-center="'Télécharger'"
                >
                  <i class="fa fa-download"></i>
                </button>
                <button
                    v-if="this.document.page !== 'partner'"
                    @click="$refs[`${document.code}`].click()"
                    class="btn btn-default btn-circle"
                    v-tooltip.top-center="'Editer'"
                >
                  <i class="fa fa-pencil" style="color: inherit"></i>
                </button>
                <button
                    v-if="document.valid === true && this.document.page !== 'partner'"
                    class="btn btn-none btn-sm text-info"
                >
                  <small><i class="fa fa-check"></i> Conforme</small>
                </button>
                <button
                    v-if="document.valid === null && this.document.page !== 'partner'"
                    @click="showValidationModal()"
                    v-tooltip.top-center="'Valider ce document'"
                    class="btn btn-primary btn-sm"
                >
                  <small><i class="fa fa-gavel"></i>  Conforme</small>
                </button>
                <span
                    v-if="document.valid === false && this.document.page !== 'partner'"
                    v-tooltip.top-center="'Ce document est non conforme'"
                    class="notValid"
                >
                  <small><i class="fa fa-times"></i>  Non conforme</small>
                </span>
              </template>
              <template v-else>
                <button
                    v-if="this.document.page !== 'partner' && !uploadFileIsLoading"
                    @click="$refs[`${document.code}`].click()"
                    class="btn btn-primary btn-circle"
                    v-tooltip.top-center="'Déposer le document'"
                >
                  <i class="fa fa-plus"></i>
                </button>
                <spinner-circle class="float-right" :displayNone="!uploadFileIsLoading"/>
              </template>
            </div>
          </div>                             
          <div v-else class="text-right m-r">
            <button
              v-if="document.status === null && this.document.page !== 'partner'"
              @click="askForNewCG"
              v-tooltip.top-center="'Effectuer la demande'"
              class="btn btn-primary btn-sm" >
              <small><i class="fa fa-gavel"></i>  Effectuer la demande</small>
            </button>
            <span v-if="document.status === 'feuvert' && this.document.page !== 'partner'">
              Démarches effectuées par Feu Vert
            </span>
            <span v-if="document.status === 'carizy' && this.document.page !== 'partner'">
              Démarches effectuées
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import gql from 'graphql-tag'
    import SpinnerCircle from '@/components/spinners/SpinnerCircle'

    export default {
    components: {
          SpinnerCircle
      },
    props: {
      document: {
        type: Object,
        required: true
      },
      subSection: {
        type: Boolean
      },
      command: {
          type: Object,
          required: true
      },
      ownerInformation: {
          type: Object
      },
      futureOwner: {
          type: Object
      },
      dataForValidationPopup: {
          type: Object
      },
      required: {
          type: Boolean,
          default: false
      }
    },

    data: () => ({
      info: {
        proc: "Les procurations sont obligatoires pour les titulaires qui ne peuvent pas être présent au rdv de cession",
        idBenef: "Un seul fichier avec les pièces d'identité de tous les bénéficiaires effectifs détenant plus de 25% de la société titulaire du compte de paiement",
        kbis: "Un KBIS de moins de trois mois de la société titulaire de compte de paiement",
        capital: "Si la composition du capital n'est pas dans les status de la société. Documments acceptés : CERFA N°2035-F, ou la liasse fiscale, ou le document relatif au bénéficiaire effectif d'une société du Greffe du Tribunal de Commerce, ou un corrier signé du représentant légal de la société.",
        rib: "Indiquant la raison social",
        iban: "IBAN de la société titulaire du compte de paiement",
        otherId: "Pour les RIB de banque de ligne, un document d'identité supplémentaire (carte d'identité recto verso, passport, permis de conduire ou Justificatif de domicile) sera demandé",
        newCG: "Idenfiant de connexion sur le site"
      },
      infoPartner: {
        warrantyMecanique: "Imprimer en 1 exemplaire en recto. Puis le faire signer par l'acheteur et le prendre en photo dans Experizy avant de le remettre à l’acheteur.",
        bankCheck: "À comparer au chèque donné par l’acheteur le jour du rdv.",
        procuration: "Pour vérifier l’identité des mandants et mandataires.",
        nonPedge: "À imprimer pour le remettre à l’acheteur (le véhicule doit être non gagé pour la vente)."
      },
      validDocumentCheckBox: false,
      uploadFileIsLoading: false
    }),

    computed: {
      documentRed () {
          if(!this.document.id){
              return true
          } else if (!this.document.valid && this.document.page === 'partner') {
              return true
          } else {
              return false
          }
      },
      documentOrange () {
          if(this.document.page === 'partner'){
              return false
          } else if (this.document.id && !this.document.valid) {
              return true
          } else {
              return false
          }
      },
      showShowIcon () {
          if(!this.document.valid && this.document.page === 'partner'){
              return false
          } else {
              return true
          }
      },
      showDownloadIcon () {
          if(!this.document.valid && this.document.page === 'partner'){
              return false
          } else {
              return true
          }
      },
      displayDocument () {
          if(
              (this.document.code !== 'consVisit' && this.document.code !== 'vehicleInspection' && this.document.code !== 'warrantyMecanique' && this.document.code !== 'signedWarrantyMecanique' && this.document.code !== 'procuration') ||
              (this.document.code === 'consVisit' && this.command.vehicule[0].over4years) ||
              (this.document.code === 'vehicleInspection' && this.command.vehicule[0].over4years) ||
              (this.document.code === 'warrantyMecanique' && this.command.options !== null && [16, 17, 20, 21].includes(this.command.options[0].id)) ||
              (this.document.code === 'signedWarrantyMecanique' && this.command.options !== null && [16, 17, 20, 21].includes(this.command.options[0].id)) ||
              (this.document.code === 'procuration' && this.document.page !== 'partner') ||
              (this.document.code === 'procuration' && this.document.page === 'partner' && this.document.id)
          ) {
              return true
          } else {
              return false
          }
      }
    },

    mounted () {
        this.$bus.$on('submit-valid-document-' + this.document.id.toString(), this.submitValidDocument)
    },

    methods: {
        async uploadFile(e, type) {
            try {
                this.uploadFileIsLoading = true

                const base64File = await this.getBase64(e.target.files[0])
                const oldDocumentId = this.document.id

                if(
                    type === 'carRegistration' ||
                    type === 'consVisit' ||
                    type === 'vehicleInspection' ||
                    type === 'nonPedge' ||
                    type === 'warrantyMecanique' ||
                    type === 'signedWarrantyMecanique' ||
                    type === 'disposal' ||
                    type === 'orderFormSigned' ||
                    type === 'buyerDeliveryFormSigned' ||
                    type === 'bankCheck' ||
                    type === 'insuranceCertificate' ||
                    type === 'sellerMandate' ||
                    type === 'buyerCerfa' ||
                    type === 'warrantyCertificateCarizy'
                ) {
                    const resultProjectDocument = await this.$apollo.mutate({
                        mutation: gql`
                          mutation {
                            uploadProjectDocument (orderId:${this.command.id}, files: {
                              type: "${type}", base64_file: "${base64File}"}) {
                              files {
                                id,
                                filesize,
                                type
                              }
                            }
                          }`
                    })

                    this.document.id = resultProjectDocument.data.uploadProjectDocument.files[0].id
                    this.document.valid = null
                    this.validDocumentCheckBox = false
                    this.updateCheckedValidDocumentsList(oldDocumentId, false)
                    this.$bus.$on('submit-valid-document-' + this.document.id.toString(), this.submitValidDocument)
                }

                if(
                    type === 'idCardRecto' ||
                    type === 'idCardVerso' ||
                    type === 'bankAccountIdentity' ||
                    type === 'procuration' ||
                    type === 'beneficiaryId' ||
                    type === 'companyRegistration' ||
                    type === 'companyStatus' ||
                    type === 'capitalComposition' ||
                    type === 'iban' ||
                    type === 'proofOfAddress' ||
                    type === 'driverLicenceRecto' ||
                    type === 'driverLicenceVerso' ||
                    type === 'residencePermit' ||
                    type === 'additionalId' ||
                    type === 'insuranceCertificate' ||
                    type === 'sellerMandate' ||
                    type === 'buyerCerfa' ||
                    type === 'warrantyCertificateCarizy'
                ) {

                    let idCustomer = ""
                    if(this.document.user === "owner"){
                        idCustomer = this.ownerInformation.owners.owner.documentId
                    } else if (this.document.user === "coOwner"){
                        idCustomer = this.ownerInformation.owners.coOwner.documentId
                    } else if (this.document.user === "seller"){
                        idCustomer = this.command.seller[0].id
                    } else if (this.document.user === "futureOwner"){
                        idCustomer = this.futureOwner.owner.documentId
                    } else if (this.document.user === "buyer"){
                        idCustomer = this.command.buyer[0].id
                    }

                    let resultCustomerDocument = ""
                    if(this.document.user === "owner" || this.document.user === "coOwner" || this.document.user === "futureOwner" ){
                        resultCustomerDocument = await this.$apollo.mutate({
                            mutation: gql`
                          mutation {
                            uploadCustomerDocument (documentId:${idCustomer}, files: {type: "${type}", base64_file: "${base64File}"}) {
                              files {
                                id,
                                filesize,
                                type
                              }
                            }
                          }`
                        })
                    } else if (this.document.user === "seller" || this.document.user === "buyer"){
                        resultCustomerDocument = await this.$apollo.mutate({
                            mutation: gql`
                          mutation {
                            uploadCustomerDocument (customerId:${idCustomer}, files: {
                              type: "${type}", base64_file: "${base64File}"}) {
                              files {
                                id,
                                filesize,
                                type
                              }
                            }
                          }`
                        })
                    }

                    this.document.id = resultCustomerDocument.data.uploadCustomerDocument.files[0].id
                    this.document.valid = null
                    this.validDocumentCheckBox = false
                    this.updateCheckedValidDocumentsList(oldDocumentId, false)
                    this.$bus.$on('submit-valid-document-' + this.document.id.toString(), this.submitValidDocument)
                  }

                  this.uploadFileIsLoading = false
            } catch (e) {
                this.showBanner('danger', 'Une erreur est survenue lors de l\'enregistrement du document.')
                this.uploadFileIsLoading = false
            }
        },
        getBase64Document (id) {
            const query = gql`
          query {
            showDocument(
            files: {
              fileId: ${id}
            })
            {
              files {
                base64
                id
                filename
              }
            }
          }`

            return this.$apollo.query({
                query: query
            })
        },
        async fetchDocument (id) {
            try {
                if (this.document.title === 'Procuration') {
                    var base64 = this.$parent.$parent.procurationDocument.url;
                } else {
                    var response = await this.getBase64Document(id);
                    var base64 = response.data.showDocument.files[0].base64;
                }

                this.showFileViewer({
                    image: base64
                })
            } catch (e) {
                this.showBanner('danger', 'Le document associé n\'a  pu être récupéré.');
            }
        },
        async downloadDocument (id) {
            try {
                if (this.document.title === 'Procuration') {
                    var base64 = this.$parent.$parent.procurationDocument.url;
                } else {
                    var response = await this.getBase64Document(id);
                    var base64 = response.data.showDocument.files[0].base64;
                    var filename = response.data.showDocument.files[0].filename
                }
                this.downloadFileFromBase64(base64, filename);
            } catch (e) {
                this.showBanner('danger', 'Le document associé n\'a  pu être récupéré.');
            }
        },
        updateCheckedValidDocumentsList (id, fromCheckbox) {
            if(fromCheckbox){
                this.$emit("updateCheckedValidDocumentsList", {'id':id, 'checked':!this.validDocumentCheckBox})
            } else {
                this.$emit("updateCheckedValidDocumentsList", {'id':id, 'checked':this.validDocumentCheckBox})
            }
        },
        async showValidationModal(){
            const document = this.document
            const command = this.command
            const dataForValidationPopup = this.dataForValidationPopup

            let documentBase64 =""
            if(document.id){
                const response = await this.getBase64Document(document.id)
                documentBase64 = response.data.showDocument.files[0].base64
            }

            this.showModal({
                childVue: 'document-validation',
                size: 'modal-lg',
                dataModel: {document, documentBase64, dataForValidationPopup, command},
            })
        },
        async submitValidDocument(data){
          const result = await this.$apollo.mutate({
              mutation: gql`
                mutation {
                  validateDocument (orderId:${this.command.id}, documents:{id: ${data.id} , valid: ${data.valid}}) {
                    documents {
                        id
                        valid
                    }
                  }
                }`
          })

          this.document.valid = data.valid
        },
        async askForNewCG(){
            const newValue = true

            const result = await this.$apollo.mutate({
                mutation: gql`
                mutation {
                  setNewCarRegistrationDeclaredByUs (orderId:${this.command.id}, newValue: ${newValue}) {
                    result
                  }
                }`
            })

            this.document.status = 'carizy'
        }
    }
  }
</script>

<style>
  .fa-info-circle, .fa-download, .fa-envelope {
    margin-left: 8px;
    margin-right: 12px;
  }
  button {
    margin-left: 5px;
  }
  .notValid {
    margin-left: 5px;
    font-size: 17px;
    color: red;
    padding-top: 2px;
  }
  .document-label .checkmark {
    top: 5px;
  }
  .btn-info-doc {
    background: none !important;
    border: none !important;
    box-shadow: none !important;
  }
  .btn-info-doc .fa {
    margin: 0;
    font-size: 16px;
  }
</style>
